import { connect } from 'react-redux';
import { withStyles } from '@mui/styles';
import SignIn from './SignIn';
import styles from './styles';

function mapStateToProps(state) {
  const {
    isLoading, data, error, message, loginSuccess,
  } = state.auth;
  return {
    isLoading,
    data,
    error,
    message,
    loginSuccess,
  };
}

const Styled = withStyles(styles)(SignIn);

export default connect(
  mapStateToProps,
)(Styled);
